export default __webpack_public_path__ + "static/media/linkedin.930f54eb.svg";